/* eslint-disable react-hooks/exhaustive-deps,import/prefer-default-export */
/* eslint-disable react/forbid-prop-types */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useUserCardProvider } from '../../../../utilities/sharedHooks/user';

import {
  CardContainer,
  FlipButton,
  CardHolderDisplayName,
  CVVLabel,
  BlackRow,
  EXPLabel,
  ValidUntilDate,
  CVVValue,
  IBAN,
  TopText,
  CointsLogo,
  WaterMark,
  BottomText,
  MonavateLogo,
  PinLabel,
  PinValue,
} from './partials';
import { cardProviders } from '../../../../screens/Card/constants';
import MonavateCardBack from '../MonavateCardBack';

const Slot = ({ children }) => children;
export const ActiveCardBack = ({
  details = null,
  isShowSecretInfo = false,
  securityNumbersForm,
  ...props
}) => {
  const { cardProvider } = useUserCardProvider();

  const { visibleOnGalileo, visibleOnMonavate } = useMemo(
    () => ({
      visibleOnGalileo: cardProvider === cardProviders.GALILEO,
      visibleOnMonavate: cardProvider === cardProviders.MONAVATE,
    }),
    [cardProvider]
  );

  const handleOnClickFlip = () => {
    props.flip();
    props.showSecretInfo();
  };

  if (visibleOnMonavate) {
    return (
      <MonavateCardBack
        details={details}
        isShowSecretInfo={isShowSecretInfo}
        securityNumbersForm={securityNumbersForm}
        flip={props.flip}
        toggleCvvModal={props.toggleCvvModal}
        showSecretInfo={props.showSecretInfo}
      />
    );
  }

  return (
    <CardContainer>
      <CointsLogo isVisible={visibleOnGalileo} />
      <MonavateLogo isVisible={visibleOnMonavate} />
      <BlackRow />
      <WaterMark isVisible={visibleOnMonavate || visibleOnGalileo} />
      <IBAN
        isShowSecretInfo={isShowSecretInfo}
        isLoadingPAN={securityNumbersForm?.isLoadingPAN}
        cardProvider={cardProvider}
        cardNumberObscured={details?.cardNumberObscured || details?.card_masked_number}
        pan={securityNumbersForm?.pan}
        onClick={props.toggleCvvModal}
        panError={securityNumbersForm?.panError}
      />
      <EXPLabel cardProvider={cardProvider} />
      <ValidUntilDate cardValidThrough={details?.cardValidThrough} />
      <CVVLabel cardProvider={cardProvider} />
      <CVVValue
        isShowSecretInfo={isShowSecretInfo}
        isLoadingCVC={securityNumbersForm?.isLoadingCVC}
        cvc={securityNumbersForm?.cvc}
        onClick={props.toggleCvvModal}
        cvcError={securityNumbersForm?.cvcError}
      />
      <PinLabel isVisible={visibleOnMonavate} cardProvider={cardProvider} />
      <PinValue
        isVisible={visibleOnMonavate}
        cardProvider={cardProvider}
        onClick={props.togglePinModal}
      />
      <CardHolderDisplayName displayName={details?.cardDisplayName} />
      <BottomText cardProvider={cardProvider} />
      <TopText cardProvider={cardProvider} />
      <Slot dsc="third">
        <FlipButton onClick={handleOnClickFlip} />
      </Slot>
    </CardContainer>
  );
};

ActiveCardBack.propTypes = {
  details: PropTypes.object,
  flip: PropTypes.func.isRequired,
  toggleCvvModal: PropTypes.func.isRequired,
  togglePinModal: PropTypes.func.isRequired,
  isShowSecretInfo: PropTypes.bool,
  showSecretInfo: PropTypes.func.isRequired,
  securityNumbersForm: PropTypes.object.isRequired,
};
